import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=1ade9d8c"
import script from "./HeaderSearch.vue?vue&type=script&lang=ts"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts"
import style0 from "./HeaderSearch.vue?vue&type=style&index=0&id=1ade9d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports